import { useState } from 'react';
import { PropTypes } from 'prop-types';
import MKBox from 'components/MaterialKit/MKBox';
import MKTypography from 'components/MaterialKit/MKTypography';
import Image from 'components/Image';
import Button from 'components/Button';
import { useAuth } from 'contexts/auth';
import { useNavigate } from 'react-router-dom';
import UserLogoutModal from './UserLogoutModal';
import userImage from '../../assets/image/user.png';

const HeaderUserInfo = ({ fontColor }) => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  const openModal = () => {
    setIsLogoutModalOpen(true);
  };

  const closeModal = () => {
    setIsLogoutModalOpen(false);
  };

  const tryOpenModal = () => {
    if (isLogoutModalOpen) {
      closeModal();
    } else {
      openModal();
    }
  };

  const onClickUserInfo = () => {
    if (auth.user?.email) {
      navigate(`/users/edit?username=${auth.user.email}`);
    }
  };

  return (
    <MKBox
      display="flex"
    >
      <MKBox display="flex" flexDirection="column" mr="1rem" sx={{ cursor: 'pointer' }} onClick={onClickUserInfo}>
        <MKTypography variant="h5" color={fontColor}>
          {auth.user?.display_name || ''}
        </MKTypography>
        <MKTypography variant="h6" color={fontColor}>
          {auth.user?.email || ''}
        </MKTypography>
      </MKBox>
      <MKBox display="flex" position="relative" alignItems="center">
        <Button
          variant="text"
          onClick={tryOpenModal}
          sx={{
            border: 'none',
            background: 'none',
            padding: 0,
            cursor: 'pointer',
          }}
        >
          <Image
            src={auth.user?.profile_image || userImage}
            alt="User profile avatar"
            width="2rem"
            height="2rem"
            borderRadius="50%"
            loading="lazy"
          />
        </Button>
        <UserLogoutModal isOpen={isLogoutModalOpen} onClose={closeModal} />
      </MKBox>
    </MKBox>
  );
};

HeaderUserInfo.propTypes = {
  fontColor: PropTypes.string,
};

export default HeaderUserInfo;
